import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dispatch, SetStateAction } from "react";

export interface IHeaderPerguntasERespostas {
    setMostrarPerguntasERespostas: Dispatch<SetStateAction<boolean>>;
}

export default function HeaderPerguntasERespostas(
    props: IHeaderPerguntasERespostas
) {
    return (
        <div className="d-flex justify-content-center w-100 align-items-center mt-n5 mb-3">
            <button
                type="button"
                className="btn btn-link font-weight-bold mr-2"
                onClick={() => {
                    props.setMostrarPerguntasERespostas(false);
                }}
            >
                <FontAwesomeIcon icon={faPlus} size="lg" /> Adicionar Pergunta
            </button>
        </div>
    );
}
